import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton';
import Post from '../../../../../utils/Post';
import Verifiers from '../../../../../utils/Verifiers.jsx';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import ListaNuevosRegistrosSiembraCampo from './ListaNuevosRegistrosSiembraCampo';

/**
 * Agrega registros nuevos a la lista de siembra directa
 * @param {funcion} close función para cerrar el componente, se retorna falso cuando solo se cierra y true cuando se guardan los datos
 * @returns 
 */
const AgregarSiembraCampo = (p) => {
    const close = p.close ?? (() => { });
    const edicion = p.registroEdicion ?? null;
    const titulo = edicion ? 'Edición de registro' : "Nuevos registros de siembra fuera de vivero";
    const titulo_estilo = 'w-100 text-400 mb-0 p-1 text-center h4 bg-black text-white round-top-m';
    const descripcion = edicion ? "Ajuste los datos del registro y pulse el botón actualizar" : "Agrega los registros de siembra de plantas y juncos fuera de vivero para asociarlos a un plan de campo";
    const descripcion_estilo = 'w-100 text-300 mb-2 mt-0 p-0 text-center text-s'
    const input_estilo = 'form-control form-control-sm border shadow-sm'
    const form_group_estilo = 'form-group m-0 mt-1 bw-150'
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [formulario, setformulario] = useState({
        id: edicion?.id ?? null,
        flor: edicion?.flor ?? "",
        variedad: edicion?.variedad ?? "",
        color: edicion?.color ?? "",
        semana_trasplante: edicion?.semana_trasplante ?? "",
        semana_corte: edicion?.semana_corte ?? "",
        ciclo_campo: edicion?.ciclo_campo ?? "",
        plantas: edicion?.plantas ?? 0,
        germinacion: edicion?.germinacion ?? 0,
        semillas: edicion?.semillas ?? 0,
        densidad: edicion?.densidad ?? 0,
        metros2: edicion?.metros2 ?? 0,
        recuperacion: edicion?.recuperacion ?? 0,
        tallos: edicion?.tallos ?? 0
    });
    const keys = ['bloque', 'semana_siembra', 'semana_trasplante', 'semana_corte', 'ciclo_campo', 'plantas', 'germinacion', 'semillas', 'densidad', 'metros2', 'recuperacion', 'tallos'];
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const [selectOptions, setselectOptions] = useState({ tipos_flor: [], flores: [], variedades: [], colores: [] });
    const [showOptions, setshowOptions] = useState({ flores: [], variedades: [], colores: [] });
    const [listeRegistros, setlisteRegistros] = useState([]);

    var counter = 0;

    useEffect(() => {
        if (counter === 0) {
            getFormularios();
            counter++;
        }
    }, []);

    const autorellenoFlorVariedadColor = (selectedOptions) => {
        if (!edicion) return;
        let variedades = filtrarVariedades(edicion.flor, selectedOptions);
        let colores = filtrarColores(edicion.flor, edicion.variedad, selectedOptions);
        setshowOptions({ ...showOptions, variedades, colores, flores: selectedOptions.flores });
    }

    const keyGen = () => {
        counter++;
        return counter + "agregarSiembraCampo";
    }

    const getFormularios = async () => {
        let resp = await Post('campo/v2/siembra/formularios', {}, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error al obtener los datos iniciales', 'error');
            return;
        }
        setselectOptions(resp.data);
        setshowOptions({ ...showOptions, flores: resp.data.flores });
        autorellenoFlorVariedadColor(resp.data);
    }

    const eliminarRegistroDelServidor = async () => {
        if (!edicion) return;
        let resp = await Post('campo/v2/siembra/delete', { id: edicion?.id }, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error al guardar los datos', 'error');
            return;
        }
        close(true);
    }

    const actualizarRegistrosServidor = async () => {
        if (!edicion) return;
        let registro_actualizado = JSON.parse(JSON.stringify(formulario));
        registro_actualizado.semana_siembra = registro_actualizado.semana_trasplante;
        let resp = await Post('campo/v2/siembra/update', { registro: registro_actualizado }, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error al actualizar el registro', 'error');
            return;
        }
        close(true);
    }

    const cambiarFlorVaridadColor = (tipo, valor) => {
        let options = { ...showOptions }
        let formCopy = { ...formulario }
        valor = Verifiers.numberParser(valor, "");
        if (tipo === 'flor') {
            options = { ...options, variedades: filtrarVariedades(valor), colores: [] };
            formCopy = { ...formCopy, flor: valor, variedad: "", color: "" };
        } else if (tipo === 'variedad') {
            options = { ...options, colores: filtrarColores(formCopy.flor, valor) };
            formCopy = { ...formCopy, variedad: valor, color: "" };
        } else formCopy = { ...formCopy, color: valor };
        setshowOptions(options);
        setformulario(formCopy);
    }

    /**
      * Filtrador, los datos e la flor seleccionada y devuelve la lista de variedades disponibles
      * @param {number} florID id de la flor que se utiliza para filtrar las opciones disponibles en los tipos flor con ese id
      * @returns {List} Lista de objetos con las opciones disponibles
    */
    const filtrarVariedades = (florID, selectOptionss = { ...selectOptions }) => {
        if (florID === "") return [];
        let tiposFlor = [...selectOptionss.tipos_flor];
        let diponibles = {};

        let len = tiposFlor.length;
        for (let i = 0; i < len; i++) {
            if (tiposFlor[i].flor === florID) {
                let varidadID = tiposFlor[i].variedad;
                diponibles[varidadID] = true;
            }
        }
        //Utilizando los id de las varidades que coinicidieron obtenemos las variedades o colores diponibles como objetos
        let variedades = selectOptionss.variedades;
        len = variedades.length;
        for (let i = 0; i < len; i++) {
            let idString = variedades[i].id + "";
            if (diponibles[idString]) diponibles[idString] = variedades[i];
        }
        return Object.values(diponibles);
    }

    /**
     * Filtrador, los datos e la flor y variedad seleccionada y devuelve la lista de colores disponibles
     * @param {number} florID id de la flor que se utiliza para filtrar las opciones disponibles en los tipos flor con ese id
     * @param {number} variedadID id de la variedad que se utiliza para filtrar las opciones disponibles en los tipos flor con ese id
     * @returns {List} Lista de objetos con las opciones disponibles
   */
    const filtrarColores = (florID, variedadID, selectOptionss = { ...selectOptions }) => {
        if (florID === "" || variedadID === "") return [];
        let tiposFlor = [...selectOptionss.tipos_flor];
        let diponibles = {};

        let len = tiposFlor.length;
        for (let i = 0; i < len; i++) {
            if (tiposFlor[i].flor === florID && tiposFlor[i].variedad === variedadID) {
                let colorID = tiposFlor[i].color;
                diponibles[colorID] = true;
            }
        }
        //Utilizando los id de las varidades que coinicidieron obtenemos las variedades o colores diponibles como objetos
        let colores = selectOptionss.colores;
        len = colores.length;
        for (let i = 0; i < len; i++) {
            let idString = colores[i].id + "";
            if (diponibles[idString]) diponibles[idString] = colores[i];
        }
        return Object.values(diponibles);
    }

    const changeValue = (e) => {
        let { name, value } = e.target;
        let newForm = { ...formulario, [name]: value };
        if (['semana_trasplante', 'ciclo_campo'].includes(name)) newForm = ajusteSemanaCorte(newForm);
        else if (['plantas', 'germinacion', 'densidad', 'recuperacion'].includes(name)) newForm = calcular_cantidades(newForm);
        setformulario(newForm);
    }

    /**
     * Cuando se ajusta el ciclo de campo o la semana de corte se se ajusta la semana de corte, esta función lo hace y refresca el formulario
     * @param {Object} form 
     */
    const ajusteSemanaCorte = (form) => {
        let ciclo_campo = Verifiers.numberParser(form.ciclo_campo, "");
        let semana_trasplante = Verifiers.numberParser(form.semana_trasplante, "");
        if (ciclo_campo === "" || semana_trasplante === "") return { ...form, semana_corte: "" };
        let semana_corte = sumarSemanas(semana_trasplante, ciclo_campo);
        return { ...form, semana_corte: semana_corte ? semana_corte : "" };
    }

    /**
     * Verifica que un valor recibido sea una semana co formato válido en el cotexto de floricents (año + semana), si esválido devuelve un arreglo con el año y la semana en valor numerico
     * @param {String} semana 
     */
    const verificarSemana = (semana) => {
        if (semana.length !== 4) return false;
        let anio = Verifiers.numberParser(semana.substring(0, 2), 0);
        let sem = Verifiers.numberParser(semana.substring(2, 4), 0);
        if (anio < 20 || sem < 1 || sem > 52) return false;
        return [anio, sem];
    }

    /**
     * Suma un numero a una semana en formato floricents (año + semana) y devuelve la nueva semana en formato
     * @param {String} semanaFormato semana en formato floricents (año + semana)
     * @param {Number} semanasNumero numero de semanas a sumar o restar en caso de ser un valor negativo
     */
    const sumarSemanas = (semanaFormato, semanasNumero) => {
        let semana = verificarSemana(`${semanaFormato}`);
        if (!semana) return false;
        let anio = semana[0];
        let sem = semana[1] + semanasNumero;
        if (sem > 52) {
            sem = sem - 52;
            anio++;
        } else if (sem < 1) {
            sem = 52 - sem;
            anio--;
        }
        return anio + "" + (sem + "").padStart(2, "0");
    }

    /**
     * Evalúa los datos de la siembra y calcula las cantidades que se pueden obtener de los datos que se llenan en automático
     * @param {Object} form formulario con los datos de la siembra
     * @returns {Object} formulario con los datos calculados
     */
    const calcular_cantidades = (form) => {
        let plantas = Verifiers.numberParser(form.plantas, 0);
        let germinacion = Verifiers.numberParser(form.germinacion, 0);
        let densidad = Verifiers.numberParser(form.densidad, 0);
        let recuperacion = Verifiers.numberParser(form.recuperacion, 0);

        //Primero verificams que si los datos no estan en el rango de lo permitido se ajusten
        if (plantas < 0) plantas = 0;
        if (germinacion < 0) germinacion = 0;
        if (germinacion > 1) germinacion = 1;
        if (densidad < 0) densidad = 0;
        if (recuperacion < 0) recuperacion = 0;
        if (recuperacion > 8) recuperacion = 8;

        //calculamos las cantidades que se pueden obtener de los datos
        form.plantas = plantas;

        form.germinacion = germinacion;
        form.semillas = germinacion === 0 ? 0 : Math.ceil(plantas / germinacion);

        form.densidad = densidad;
        form.metros2 = densidad === 0 ? 0 : +(plantas / densidad).toFixed(2);

        form.recuperacion = recuperacion;
        form.tallos = recuperacion === 0 ? 0 : Math.floor(plantas * recuperacion);
        return form;
    }

    /**
     * Genera un input con su label para el formulario y ahorrar código en la generación de los inputs
     * @param {string} title titulo del input
     * @param {string} type tipo de dato, number, text, etc
     * @param {string} name nombre del campo en el formulario
     * @param {boolean} disabled si el campo es editable o no
     * @returns {JSX.Element} con el input y su label asicom la función para editar el valor del formulario
     */
    const inputRender = (title, type, name, disabled = false) => (
        <div className={form_group_estilo}>
            <label className='text-bold w-100 text-s text-start ms-1'>{title}</label>
            <input type={type} name={name} className={input_estilo} value={formulario[name]} onChange={changeValue} disabled={disabled} />
        </div>
    )

    const puedeAgregar = () => {
        if (
            formulario.flor === "" ||
            formulario.variedad === "" ||
            formulario.color === "" ||
            !verificarSemana(formulario.semana_trasplante) ||
            !verificarSemana(formulario.semana_corte) ||
            formulario.ciclo_campo === "" ||
            formulario.plantas === 0 ||
            formulario.germinacion === 0 ||
            formulario.semillas === 0 ||
            formulario.densidad === 0 ||
            formulario.metros2 === 0 ||
            formulario.recuperacion === 0 ||
            formulario.tallos === 0) {
            return false;
        }
        return true;
    }

    const agregarAlaLista = () => {
        let lista = [...listeRegistros];
        let registro = JSON.parse(JSON.stringify(formulario));
        registro.semana_siembra = registro.semana_trasplante;
        let florNombre = showOptions.flores.find((f) => f.id === registro.flor).nombre;
        let variedadNombre = showOptions.variedades.find((f) => f.id === registro.variedad).nombre;
        let colorNombre = showOptions.colores.find((f) => f.id === registro.color).nombre;
        registro.bloque = `${florNombre} ${variedadNombre} ${colorNombre}`;
        lista.push(registro);
        lista.sort((a, b) => a.semana_siembra - b.semana_siembra);
        lista.sort((a, b) => a.bloque.localeCompare(b.bloque));
        setlisteRegistros(lista);
    }

    /**
     * Elimina un lemento d ela lista de registros a agregar cuando no se está en modo de edición
     * @param {number} i indice del elmento a eliminar
     */
    const eliminarElementoLista = (i) => {
        let lista = [...listeRegistros];
        lista.splice(i, 1);
        setlisteRegistros(lista);
    }

    return (
        <div className='vw-100 vh-100 blur-xxl p-1' style={{ overflow: "auto", zIndex: "9999", position: "fixed", top: 0, left: 0 }}>
            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-1400 bg-white shadow round-m p-0 text-center'>
                    <div className={titulo_estilo}>{titulo}</div>
                    <div className={descripcion_estilo}>{descripcion}</div>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>

                        {/*select flor*/}
                        <div className={form_group_estilo}>
                            <label className='text-bold w-100 text-s text-start ms-1'>Flor</label>
                            <select className={input_estilo} value={formulario.flor} onChange={(e) => cambiarFlorVaridadColor('flor', e.target.value)}>
                                <option value='' >Seleccione una</option>
                                {showOptions.flores.map((f) => {
                                    return <option key={keyGen()} value={f.id}>{f.nombre}</option>
                                })}
                            </select>
                        </div>

                        {/*select Variedad*/}
                        <div className={form_group_estilo}>
                            <label className='text-bold w-100 text-s text-start ms-1'>Variedad</label>
                            <select className={input_estilo} value={formulario.variedad} onChange={(e) => cambiarFlorVaridadColor('variedad', e.target.value)}>
                                <option value='' >Seleccione una</option>
                                {showOptions.variedades.map((f) => {
                                    return <option key={keyGen()} value={f.id}>{f.nombre}</option>
                                })}
                            </select>
                        </div>

                        {/*select color*/}
                        <div className={form_group_estilo}>
                            <label className='text-bold w-100 text-s text-start ms-1'>Color</label>
                            <select className={input_estilo} value={formulario.color} onChange={(e) => cambiarFlorVaridadColor('color', e.target.value)}>
                                <option value='' >Seleccione una</option>
                                {showOptions.colores.map((f) => {
                                    return <option key={keyGen()} value={f.id}>{f.nombre}</option>
                                })}
                            </select>
                        </div>
                        {inputRender('S. siembra', 'number', 'semana_trasplante', true)}
                        {inputRender('S. trasplante', 'number', 'semana_trasplante', false)}
                        {inputRender('S. corte', 'number', 'semana_corte', true)}
                        {inputRender('Ciclo campo', 'number', 'ciclo_campo', false)}
                        <div className='w-100 mt-3' />
                        {inputRender('Núm. plantas', 'number', 'plantas', false)}
                        {inputRender('Germinación', 'number', 'germinacion', false)}
                        {inputRender('Semillas', 'number', 'semillas', true)}
                        {inputRender('Densidad', 'number', 'densidad', false)}
                        {inputRender('Metros² necesarios', 'number', 'metros2', true)}
                        {inputRender('Recuperación', 'number', 'recuperacion', false)}
                        {inputRender('Tallos cosecha', 'number', 'tallos', true)}
                        <div className='w-100 mt-3' />
                        {edicion && <>
                            <div className='bw-200 mb-3'>
                                <button className='btn btn-sm btn-danger round-xxl border border-dark w-100 shadow text-bold'
                                    onClick={eliminarRegistroDelServidor} disabled={!edicion}
                                >Eliminar registro</button>
                            </div>
                            <div className='bw-350 mb-3'>
                                <button className='btn btn-sm btn-warning round-xxl border border-dark w-100 shadow text-bold'
                                    disabled={!puedeAgregar()} onClick={actualizarRegistrosServidor}
                                >Guardar cambios</button>
                            </div>
                        </>}

                        {!edicion && <>
                            <div className='bw-350'>
                                <button className='btn btn-sm btn-warning round-xxl border border-dark w-100 shadow text-bold'
                                    disabled={!puedeAgregar()} onClick={agregarAlaLista}
                                >Agregar a la lista</button>
                            </div>
                            <div className='w-100 m-0 p-0' />
                            <div className='w-70 mt-2 mb-1 border-bottom' />
                            <div className='w-100 p-1 m-0'>
                                <ListaNuevosRegistrosSiembraCampo listeRegistros={listeRegistros} close={close} eliminarElementoLista={eliminarElementoLista} />
                            </div>

                        </>}

                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default AgregarSiembraCampo;